(() => {
  'use strict';
  if (window.parent !== window || /\/pages\/planner\/?$/.test(location.pathname)) return;
  let active = null;
  const style = document.createElement('style');
  style.textContent = `.optisofa-planner-overlay{position:fixed;inset:0;margin:0;border:0;padding:0;width:100%;max-width:none;height:100%;height:100dvh;max-height:none;background:white;overflow:hidden;transform:translateY(0);isolation:isolate}.optisofa-planner-overlay.is-open{transform:translateY(0)}.optisofa-planner-overlay::backdrop{background:transparent;opacity:0;transition:none;animation:none}.optisofa-planner-overlay shopify-overlay-planner-helper>iframe{display:block;border:0;width:100%;height:100%}.optisofa-planner-overlay>button{position:absolute;right:8px;top:calc(var(--overlay-announcement-height,0px) + 8px);width:44px;height:44px;border:0;background:white;color:black;display:grid;place-items:center;z-index:3;cursor:pointer}.optisofa-planner-overlay [market-switcher-trigger]{display:none!important}@media(min-width:761px){.optisofa-planner-overlay>button{right:12px;top:calc(var(--overlay-announcement-height,0px) + 20px)}}.optisofa-planner-overlay.is-ready>button,.optisofa-planner-overlay.is-ready .optisofa-overlay-loading{display:none}.optisofa-overlay-loading{position:absolute;inset:0;display:grid;place-items:center;background:white;z-index:1}.optisofa-overlay-loading span{width:24px;height:24px;border:2px solid #d1d2f0;border-top-color:#222;border-radius:50%;animation:optisofa-overlay-spin .8s linear infinite}@keyframes optisofa-overlay-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.optisofa-overlay-loading span{animation:none}}@media(prefers-reduced-motion:reduce){.optisofa-planner-overlay{transition:none}}`;
  document.head.append(style);
  function open(url, push = true) {
    if (active) return;
    const scroll = {x:scrollX,y:scrollY};
    const focus = document.activeElement;
    const bodyStyle = document.body.getAttribute('style');
    const htmlScroll = document.documentElement.style.scrollBehavior;
    const dialog = document.createElement('dialog');
    dialog.className = 'optisofa-planner-overlay';
    dialog.setAttribute('aria-label', document.documentElement.lang.startsWith('de') ? 'Sofa konfigurieren' : 'Konfigurator sofy');
    const frame = document.createElement('iframe');
    frame.title = dialog.getAttribute('aria-label');
    frame.allow = 'clipboard-write; fullscreen; xr-spatial-tracking';
    const target = new URL(url);
    target.searchParams.set('planner_overlay','1');
    target.searchParams.set('return_url', location.href);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id',preview);
    const helper = document.createElement('shopify-overlay-planner-helper');
    helper.dataset.url = target.href;
    helper.dataset.deferStart = 'true';
    helper.style.cssText='display:block;width:100%;height:100%';
    helper.append(frame);
    const close = document.createElement('button');
    close.type='button'; close.innerHTML='<svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true"><path d="M4.5835 4.58334L17.4168 17.4167M17.4168 4.58334L4.5835 17.4167" stroke="currentColor" stroke-width="1.14583" stroke-linecap="round"/></svg>'; close.setAttribute('aria-label',document.documentElement.lang.startsWith('pl')?'Zamknij':document.documentElement.lang.startsWith('de')?'Schließen':'Close');
    close.onclick = () => dismiss(true);
    const viewport=document.createElement('div');
    viewport.style.cssText='position:absolute;inset:0;overflow:hidden';
    const loading=document.createElement('div');
    loading.className='optisofa-overlay-loading';
    loading.setAttribute('role','status');
    loading.setAttribute('aria-label',document.documentElement.lang.startsWith('pl')?'Ładowanie konfiguratora':document.documentElement.lang.startsWith('de')?'Konfigurator wird geladen':'Loading configurator');
    loading.innerHTML='<span aria-hidden="true"></span>';
    viewport.append(helper,loading);
    frame.addEventListener('load',()=>{
      if(new URL(frame.src || 'about:blank').origin === 'https://planner.optisofa.com') dialog.classList.add('is-ready');
    });
    dialog.append(viewport,close);
    const token = (!push && history.state?.optisofaOverlay?.token) || Date.now() + '-' + Math.random().toString(36).slice(2);
    active = {dialog,frame,viewport,scroll,focus,bodyStyle,htmlScroll,token,closing:false};
    const state = active;
    // the address bar shows the planner's link at once (owner 23.10), as when the planner had its own page: a link copied
    // from it or a refresh opens the planner page; × / back return to the page underneath (the entry before this one)
    const address = new URL(url.href || url, location.href);
    if (preview) address.searchParams.set('preview_theme_id',preview);
    if(push) history.pushState({...history.state,optisofaOverlay:{url:address.href,token}},'',address.href);
    // the page's scrollbar (Windows): the bar copy keeps the page's centre and the page under the overlay keeps its width,
    // otherwise the bar's text moved right by half the scrollbar when the planner opened (owner 26.10)
    const scrollbar=Math.max(0,innerWidth-document.documentElement.clientWidth);
    document.body.style.position='fixed'; document.body.style.top=`-${scroll.y}px`;
    document.body.style.left=`-${scroll.x}px`; document.body.style.width=scrollbar ? `calc(100% - ${scrollbar}px)` : '100%';
    document.body.append(dialog); dialog.showModal();
    const announcement=document.querySelector('body > .header-container__top') || [...document.querySelectorAll('.header-container__top')].find(el=>!dialog.contains(el));
    if(announcement && announcement.getBoundingClientRect().height > 0) {
      // a copy of the store's bar goes into the overlay, on the message the page shows now (owner 26.10: the bar must not
      // jump when the planner opens): moving the bar itself restarted its slider (Swiper destroys itself when moved) and
      // the bar slid in with the overlay; the page's own bar stays where it is
      const bar=announcement.cloneNode(true);
      const pageSlider=announcement.querySelector('swiper-container');
      const slider=bar.querySelector('swiper-container');
      if(slider) {
        const slides=[...slider.children].filter(el=>el.tagName==='SWIPER-SLIDE');
        slides.sort((a,b)=>(+a.dataset.swiperSlideIndex||0)-(+b.dataset.swiperSlideIndex||0)).forEach(el=>{
          el.className='announcement'; el.removeAttribute('style'); el.removeAttribute('data-swiper-slide-index'); slider.append(el);
        });
        slider.setAttribute('initial-slide',String(pageSlider?.swiper?.realIndex || 0));
      }
      active.announcement={element:announcement,bar,slider,pageSlider};
      bar.style.cssText+=`;position:absolute;top:0;left:0;right:0;width:100%;z-index:2;box-sizing:border-box;padding-right:${scrollbar}px`;
      dialog.append(bar);
      const sync=()=>{
        const height=bar.getBoundingClientRect().height;
        viewport.style.top=height+'px';
        dialog.style.setProperty('--overlay-announcement-height',height+'px');
        helper.style.height='calc(100% + 40px)';
        helper.style.transform='translateY(-40px)';
      };
      sync();
      active.announcement.observer=new ResizeObserver(sync);
      active.announcement.observer.observe(bar);
    }
    // chat widgets go into the overlay: a modal dialog is above the whole page and makes the rest of it inert, so a chat
    // left on the page opened behind the planner (OPTISOFA chat: the planner's "Pomoc" did nothing visible, 23.10)
    const CHATS = ['gorgias-chat-container','optisofa-chat'];
    const take = chat => {const saved = {chat, parent:chat.parentNode, next:chat.nextSibling}; dialog.append(chat); return saved};
    active.chats = CHATS.map(id => document.getElementById(id)).filter(Boolean).map(take);
    // a chat may be built only after the overlay opened (tablet 29.10: the tap that opens the planner is often the page's
    // first touch, and the chat loads after it): outside this modal dialog it opened under the planner, invisible, so the
    // planner's Help did nothing. A chat is moved in here as soon as it appears
    if (active.chats.length < CHATS.length) {
      state.chatWatch = new MutationObserver(() => {
        if (state.closing) return;
        for (const id of CHATS) { const chat = document.getElementById(id); if (chat && !dialog.contains(chat)) state.chats.push(take(chat)); }
        if (state.chats.length >= CHATS.length) state.chatWatch.disconnect();
      });
      state.chatWatch.observe(document.body, {childList:true, subtree:true});
    }
    // the store's "Zapytaj nas" button stays hidden in the overlay – the planner has its own "Pomoc" (the bridge shows the
    // panel when it is clicked)
    try {window.OptisofaChat?.setLauncherHidden(true)} catch {}
    dialog.addEventListener('optisofa-overlay-close', () => dismiss(true));
    dialog.addEventListener('cancel', event => {event.preventDefault();dismiss(true)});
    dialog.classList.add('is-open');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    dialog.style.willChange='transform, opacity';
    // the overlay fades in and only the planner slides up: the bar copy lies exactly over the page's bar, so it stays still
    state.motion = dialog.animate([{opacity:0},{opacity:1}], {duration:reduced ? 0 : 220,easing:'cubic-bezier(.2,.7,.2,1)',fill:'both'});
    viewport.animate([{transform:'translate3d(0,32px,0)'},{transform:'translate3d(0,0,0)'}], {duration:reduced ? 0 : 220,easing:'cubic-bezier(.2,.7,.2,1)'});
    state.motion.finished.then(() => {
      if(active !== state || state.closing) return;
      state.motion.cancel(); state.motion=null;
      dialog.style.willChange='auto';
      helper.start();
    }).catch(()=>{});
  }
  function dismiss(back) {
    const state=active;
    if (!state || state.closing) return;
    state.closing=true;
    const current=getComputedStyle(state.dialog);
    const from={opacity:current.opacity};
    // the page's bar takes the message the overlay's copy shows, so nothing changes when the overlay fades out
    try {
      const a=state.announcement;
      if(a?.pageSlider?.swiper && a.slider?.swiper) a.pageSlider.swiper.slideToLoop(a.slider.swiper.realIndex,0);
    } catch {}
    state.motion?.cancel();
    state.dialog.style.willChange='transform, opacity';
    let finished=false;
    function finish() {
      if(finished) return; finished=true;
      state.chatWatch?.disconnect();
      [...state.chats].reverse().forEach(({chat,parent,next}) => {
        if(parent?.isConnected) parent.insertBefore(chat,next?.parentNode === parent ? next : null);
      });
      try {window.OptisofaChat?.setLauncherHidden(false)} catch {}
      if(state.announcement) state.announcement.observer?.disconnect();
      state.dialog.close(); state.dialog.remove();
      document.documentElement.classList.remove('planner-chat-custom');
      if(state.bodyStyle === null) document.body.removeAttribute('style'); else document.body.setAttribute('style',state.bodyStyle);
      document.documentElement.style.scrollBehavior='auto';
      window.scrollTo(state.scroll.x,state.scroll.y);
      document.documentElement.style.scrollBehavior=state.htmlScroll;
      state.focus?.focus?.({preventScroll:true});
      active=null;
      if(back && history.state?.optisofaOverlay?.token === state.token) history.back();
    }
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduced) {finish();return;}
    state.motion=state.dialog.animate([from,{opacity:0}],{duration:140,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
    state.viewport.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d(0,20px,0)'}],{duration:140,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
    state.motion.finished.then(finish,finish);
  }
  document.addEventListener('click', event => {
    if(event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link=event.target.closest('a[href]');
    if(!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    let url; try {url=new URL(link.href)} catch{return}
    if(url.origin !== location.origin || !/\/pages\/planner\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(url);
  },true);
  window.addEventListener('message',event => {
    if(!active || event.source !== active.frame.contentWindow) return;
    if(!['https://config.optisofa.com','https://optisofa-planner-production.up.railway.app','https://planner.optisofa.com'].includes(event.origin)) return;
    if(event.data?.type === 'planner:exit:cover' || event.data?.type === 'planner:close') {
      event.stopImmediatePropagation();
      event.source.postMessage({type:event.data.type === 'planner:exit:cover' ? 'planner:exit:covered' : 'planner:closing'},event.origin);
      dismiss(true);
    }
    if(event.data?.type === 'planner:loaded') active.dialog.classList.add('is-ready');
    // the planner's session code and collection into the address bar (owner 20.10: a link copied from it opens the
    // current layout): the planner page with ?config=, as when the planner had its own page; a refresh opens it there
    // too. The overlay's history entry is replaced, so its × / back still return to the page underneath
    if(event.data?.type === 'planner:config' || event.data?.type === 'planner:family') {
      try {
        const st = history.state?.optisofaOverlay;
        if(st && st.token === active.token) {
          const u = new URL(st.url, location.href);
          if(event.data.type === 'planner:config' && /^[A-Z0-9]{4,16}$/.test(event.data.code)) { u.searchParams.set('config', event.data.code); u.searchParams.delete('fabric'); }
          if(event.data.type === 'planner:family' && ['hug','cloud','slay','lazy'].includes(event.data.family)) u.searchParams.set('family', event.data.family);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if(preview) u.searchParams.set('preview_theme_id', preview);
          history.replaceState({...history.state, optisofaOverlay:{...st, url:u.href}}, '', u.href);
        }
      } catch(e) {}
    }
  },true);
  window.addEventListener('popstate',event => {
    if(active) dismiss(false);
    else if(event.state?.optisofaOverlay) open(event.state.optisofaOverlay.url,false);
  });
})();
